import React, { useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonTextareaInput from "../../common/inputs/CommonTextareaInput";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import useInvoiceApi from "../../../hooks/useInvoiceApi";

const initData = {
  name: "",
  description: "",
  price: "",
  currency: "NGN",
};

export const CreateServiceModal = ({ setOpen, open, edit, service }) => {
  const { createService, updateService } = useInvoiceApi();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(
    edit
      ? {
          name: service?.title,
          description: service?.description?.join("\n"),
          price: service?.unitPrice,
          currency: service?.currency,
        }
      : initData
  );

  const [validation, setValidation] = useState({
    focus: { name: false, description: false, price: false },
    error: { name: false, description: false, price: false },
  });

  const handleFocus = (field) => {
    setValidation((prev) => ({
      ...prev,
      focus: { ...prev.focus, [field]: true },
      error: { ...prev.error, [field]: false },
    }));
  };

  const handleBlur = (field) => {
    if (!data?.[field]) {
      setValidation((prev) => ({
        ...prev,
        error: { ...prev.error, [field]: true },
      }));
    }
  };

  const serviceDisabled =
    !data.name || !data.description || !data.price || !data.currency;

  const handleClose = () => setOpen(false);
  const handleConfirm = async () => {
    if (edit && service) {
      await updateService({
        data: {
          title: data?.name,
          description: data?.description,
          price: data?.price,
          currency: data?.currency,
        },
        id: service?._id,
        setLoading,
        callback: () => {
          // console.log({ service, updatedService });
          setOpen(false);
        },
      });
      return;
    }
    await createService({
      data: {
        title: data?.name,
        description: data?.description,
        price: data?.price,
        currency: data?.currency,
      },
      setLoading,
      callback: () => {
        setOpen(false);
        setData(initData);
      },
    });
  };

  const Footer = () => (
    <div className="w-full flex flex-col static bottom-0">
      <hr className="border-gray-300 my-3 mb-6" />
      <div className="flex gap-4 items-center">
        <button
          className="flex items-center justify-center text-black px-10 py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleClose}
        >
          <span>Close</span>
        </button>
        <button
          className="bg-primary1 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center text-white w-full py-4 rounded-lg text-xs sm:text-lg"
          onClick={handleConfirm}
          disabled={serviceDisabled}
        >
          {loading ? (
            <div className="buttonLoader" />
          ) : (
            <span>{edit ? "Update" : "Confirm"}</span>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      secondary
      padding="px-4 py-6"
      title="Create service"
      subTitle="Enter details of your invoice"
      footer={<Footer />}
    >
      <div className="w-full flex flex-col">
        <div className="relative overflow-x-auto flex flex-col scroll-hide px-4">
          <div className="w-full gap-3 flex mt-3">
            <CommonFreeTextInput
              label="Name"
              placeholder="e.g Visa Handling"
              value={data.name}
              onChange={(val) => setData({ ...data, name: val })}
              onFocus={() => handleFocus("name")}
              onBlur={() => handleBlur("name")}
              error={validation.error.name}
            />
          </div>
          <div className="w-full gap-3 flex mt-3">
            <CommonTextareaInput
              label="Description"
              placeholder="Describe the service"
              value={data.description}
              onChange={(val) => setData({ ...data, description: val })}
              onFocus={() => handleFocus("description")}
              onBlur={() => handleBlur("description")}
              error={validation.error.description}
            />
          </div>
          <div className="w-full gap-3 flex mt-3">
            <div className="w-[150px]">
              <CommonDropdownInput
                label="Currency"
                placeholder="e.g NGN"
                options={["NGN", "USD"]}
                value={data.currency}
                onChange={(val) => setData({ ...data, currency: val })}
              />
            </div>
            <div className="flex flex-1">
              <CommonFreeTextInput
                label="Price"
                placeholder="0,000,000"
                value={data.price}
                onChange={(val) => {
                  const numeric = val.replace(/[^\d]/g, "");
                  setData({ ...data, price: numeric });
                }}
                onFocus={() => handleFocus("price")}
                onBlur={() => handleBlur("price")}
                error={validation.error.price}
              />
            </div>
          </div>
          <div className="h-20"></div>
        </div>
      </div>
    </ModalContainer>
  );
};
